export default __webpack_public_path__ + "static/media/10_thumbnail.a5bd6955.JPG";